import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
  RSelect,
} from "../../components/Component";
import Table from "../../components/react-table/Table";
import { DELETE, GET, POST, PUT } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { TRUCK_TYPE } from "../../utils/Utils";
import UpsertTruckConfig from './UpsertTruckConfig';

const PN_COMPANY_WITH_WAREHOUSE_OPTIONS = [
  {
    label: "Tấn Lộc - Tấn Lộc",
    value: "TL_TL",
  },
  {
    label: "Tấn Lộc - Bà Rịa",
    value: "TL_BR",
  },
  {
    label: "Cường Thịnh - Cường Thinh",
    value: "CT_CT",
  }
]

const DEFAULT_TRUCK_CONFIG = {
  id: "",
  customerId: "",
  companyWithWarehouseId: PN_COMPANY_WITH_WAREHOUSE_OPTIONS[0].value,
  truckId: "",
  amount: 0,
  amountForSubDriver: 0,
};



const TruckConfigManager = () => {
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [data, setData] = useState([]);
  const [pnCompanyWithWarehouseOptions] = useState(PN_COMPANY_WITH_WAREHOUSE_OPTIONS);

  const [view, setView] = useState({
    edit: false,
    add: false,
    details: false,
    isDelete: false,
  });
  const { errors, handleSubmit, reset, getValues, control, setValue, watch } = useForm(
    {
      defaultValues: DEFAULT_TRUCK_CONFIG,
    }
  );

  const companyWithWarehouseId = watch('companyWithWarehouseId');

  const [loading, setLoading] = useState(false);
  const [editId, setEditedId] = useState();
  const [deleteId, setDeleteId] = useState();
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [truckOptions, setTruckOptions] = useState([]);
  const [customerOptions] = useState({
    TL: [],
    CT: [],
  });

  const [filter, setFilter] = useState({
    customerId: searchParams.get("customerId") || undefined,
    truckId: searchParams.get("truckId") || undefined,
    companyWithWarehouseId: searchParams.get("companyWithWarehouseId") || pnCompanyWithWarehouseOptions[0].value,
  });

  const colTable = [
    {
      Header: "Biển số xe",
      accessor: (item) => item?.truck?.id || "",
    },
    {
      Header: "Mã Khách hàng",
      accessor: (item) => item?.customerId || "",
    },
    {
      Header: "Công ty - Kho",
      accessor: (item) => PN_COMPANY_WITH_WAREHOUSE_OPTIONS.find((c) => c.value === item?.companyWithWarehouseId)?.label || "",
    },
    {
      Header: "Tiền tài chính(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item?.amount || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Tiền tài phụ(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item?.amountForSubDriver || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Ngày tạo",
      accessor: (item) => moment(item.createdAt).format("DD/MM/YYYY HH:mm:ss"),
    },
    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        onEditClick(item.id);
                        toggle("edit");
                      }}
                    >
                      <Icon name="edit" className="text-primary"></Icon>
                      <span>Sửa</span>
                    </DropdownItem>

                  </li>
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setDeleteId(item.id);
                        toggle("isDelete");
                      }}
                    >
                      <Icon name="trash" className="text-danger"></Icon>
                      <span>Xoá</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];

  useEffect(() => {

    GET("truck", {
      type: TRUCK_TYPE.TRUCK
    }, true).then((resp) => {
      const { data } = resp;
      if (data && data.rows && data.rows.length) {
        setTruckOptions(
          data.rows.map((c) => ({
            label: c.id,
            value: c.id,
            data: c,
          }))
        );
      }
    });
  }, []);

  // Changing state value when searching name
  useEffect(() => {
    if (!filter.customerId) {
      return;
    }

    const newParams = new URLSearchParams({
      customerId: filter.customerId,
      ...(filter.truckId ? { truckId: filter.truckId } : {}),
      ...(filter.companyWithWarehouseId ? { companyWithWarehouseId: filter.companyWithWarehouseId } : {})

    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    });


    setLoading(true);
    setData([]);
    let params = {
      customerId: filter.customerId,
      ...(filter.truckId ? { truckId: filter.truckId } : {}),
      ...(filter.companyWithWarehouseId ? { companyWithWarehouseId: filter.companyWithWarehouseId } : {})
    };

    GET(`truck-config`, params, true)
      .then(({ data }) => {
        setData([...data?.rows]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [timeNow, filter]);


  const onEditClick = (id) => {
    setLoading(true);
    setEditedId(id);

    GET(`/truck-config/${id}`, {
    }, true)
      .then(({ data }) => {
        reset({
          ...data,
        });
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
        onFormCancel();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const resetData = () => {
    setEditedId("");
    onFormCancel();
    setTimeNow(moment().valueOf());
  };

  const onHandleSubmit = () => {
    setLoading(true);
    const { amount, customerId, truckId, amountForSubDriver, companyWithWarehouseId, } = getValues();

    const formData = {
      amount,
      customerId,
      truckId,
      amountForSubDriver: amountForSubDriver || 0,
      companyWithWarehouseId,
    };

    const request = editId
      ? PUT(`truck-config/${editId}`, formData, {}, true)
      : POST("truck-config", formData, {}, true);

    request
      .then((res) => {
        if (editId) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onFormCancel = () => {
    setView({ add: false, edit: false, isDelete: false });
    reset(DEFAULT_TRUCK_CONFIG);
  };

  const deleteOrder = (id) => {
    if (!id) {
      return;
    }
    DELETE(`truck-config/${id}`, {}, true)
      .then((res) => {
        toast.success("Xóa xe tải thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  return (
    <React.Fragment>
      <Head title="Quản lý xe"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Tiền tài xế</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">

                    <li>
                      <div className="form-group">
                        <div className="form-control-wrap">
                          <RSelect
                            placeholder={"Lọc theo công ty - kho"}
                            options={pnCompanyWithWarehouseOptions}
                            value={pnCompanyWithWarehouseOptions.find((c) => c.value === filter.companyWithWarehouseId) || null}
                            onChange={(val) => {
                              setFilter({
                                ...filter,
                                companyWithWarehouseId: val?.value || undefined,
                                customerId: customerOptions[val?.value?.split('_')[0]]?.[0]?.value || undefined,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          isClearable
                          placeholder="Biển số xe"
                          options={truckOptions}
                          value={
                            truckOptions.find(
                              (c) => c.value === filter.truckId
                            ) || ""
                          }
                          onChange={(val) => {
                            setFilter({
                              ...filter,
                              truckId: val?.value || undefined,
                            })
                          }

                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          placeholder="Khách hàng/Nhà cung cấp"
                          options={customerOptions[filter.companyWithWarehouseId?.split('_')[0]] || []}
                          value={
                            customerOptions[filter.companyWithWarehouseId?.split('_')[0]].find(
                              (c) => c.value === filter.customerId
                            ) || ""
                          }
                          onChange={(val) => {
                            setFilter({
                              ...filter,
                              customerId: val?.value || undefined,
                            })
                          }

                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div>
                        <Button
                          className="btn-primary"
                          color="primary"
                          onClick={() => {
                            onFormCancel();
                            toggle("add");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Thêm cấu hình</span>
                        </Button>
                      </div>
                    </li>
                    <li>
                      <UpsertTruckConfig reload={resetData} />
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3">
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>

        <Modal
          isOpen={view.add || view.edit}
          toggle={() => onFormCancel()}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Thêm tiền tài</h5>
              <div className="mt-4">
                <form onSubmit={handleSubmit(onHandleSubmit)}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Xe tải <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="truckId"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <RSelect
                                inputRef={ref}
                                name={name}
                                options={truckOptions}
                                value={
                                  truckOptions.find((c) => c.value === value) ||
                                  ""
                                }
                                onChange={(val) => onChange(val.value)}
                                isDisabled={editId}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="truckId"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Kho
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="companyWithWarehouseId"
                            rules={{ required: "Vui lòng nhập thông tin" }}

                            render={({ onChange, value, name, ref }) => (
                              <RSelect
                                isClearable
                                classNamePrefix="form-control"
                                inputRef={ref}
                                name={name}
                                options={pnCompanyWithWarehouseOptions}
                                value={pnCompanyWithWarehouseOptions.find(
                                  (c) => c.value === value
                                )}
                                isDisabled={editId}
                                onChange={(val) => {
                                  onChange(val?.value);
                                  setValue('customerId', null);
                                }}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="companyWithWarehouseId"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Khách hàng <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller

                            control={control}
                            name="customerId"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <RSelect
                                inputRef={ref}
                                name={name}
                                options={customerOptions[companyWithWarehouseId?.split('_')[0]] || []}
                                value={
                                  customerOptions[companyWithWarehouseId?.split('_')[0]].find(
                                    (c) => c.value === value
                                  ) || ""
                                }
                                onChange={(val) => onChange(val.value)}
                                isDisabled={editId || !companyWithWarehouseId}

                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="customerId"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>



                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Tiền tài chính(đ)<span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="amount"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <NumericFormat
                                className="form-control"
                                inputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="amount"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Tiền tài phụ(đ)<span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="amountForSubDriver"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <NumericFormat
                                className="form-control"
                                inputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="amountForSubDriver"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col size="12">
                      <Button color="primary" type="submit">
                        <Icon className="plus"></Icon>
                        <span>Thêm</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá cấu hình này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteOrder(deleteId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default TruckConfigManager;
